import React, { useRef } from 'react';
import UplynkCentralModule from './UplynkCentralModule';

const CloudSlicerCentral = ({ id, data, showAllModuleOverlays }) => {

  return (
    <>
      <UplynkCentralModule 
        dataPath="uplynkCentral.data.jobStates"
        keyMappings={{
          state: "state",
          progress: "progress",
          progressPercent: "progress_percent",
          timestamp: "timestamp"
        }}
        stateStyles={{
          states: {
            ["assigned"]: { border: 'border-indigo-500', progress: 'bg-[#a5b4fc] border-indigo-600' },
            ["done"]: { border: 'border-green-600', progress: 'bg-[#009900] border-purple-600' },  // progress: 'bg-[#8800AA] border-purple-600'
            ["error"]: { border: 'border-red-600', progress: 'bg-red-400 border-red-600' },
            ["playing"]: { border: 'border-purple-700', progress: 'bg-purple-300 border-purple-600' },
            ["starting"]: { border: 'border-blue-500', progress: 'bg-blue-200 border-blue-500' },
            ["waiting"]: { border: 'border-amber-600', progress: 'bg-amber-300 border-amber-600' },
          }
        }}
        conditions={[
          // First condition for live indicator (unchanged)
          {
            when: {
              property: "progress",
              values: ["Slicing"],
              comparison: "equals",
              and: {
                property: "progressPercent",
                value: 100,
                comparison: "lessThan"
              }
            },
            then: {
              showLiveIndicator: true
            }
          },
          // Condition for completed item (done status with Finished successfully)
          {
            when: {
              property: "state",
              values: ["done"],
              comparison: "equals",
              and: {
                property: "progress",
                values: ["Finished successfully"],
                comparison: "equals"
              }
            },
            then: {
              removeClasses: "active-item-pulse",
              setStatus: "complete", // <-- This is the new action
              isCompleted: true
            }
          },
          {
            when: {
              property: "state",
              values: ["error"],
              comparison: "equals"
            },
            then: {
              removeClasses: "active-item-pulse",
              setStatus: "canceled",
              isError: true
            }
          }
        ]}
        visualOptions={{
          height: "17rem",
          width: "17rem",
          // scrollToLatest: true, // NOT AN OPTION RIGHT NOW
          itemOrder: "", // Newest items at botom
          highlightLatestOnly: true, // Only highlight current item
          contrastRatio: 0.7, // How much to fade older items
          compactLayout: true,
          autoScrollButton: false
        }}
      />
    </>

  );
};

export default CloudSlicerCentral;